/**
 * @generated SignedSource<<86d06091cb86e6e4b6c6505c282ff654>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type PreviewWidgetListInput = {
  dataSource: string;
  size?: WidgetOverviewSize | null;
  storecastId?: string | null;
};
export type WAIntegrationListQuery$variables = {
  input: PreviewWidgetListInput;
  storecastId: string;
};
export type WAIntegrationListQuery$data = {
  readonly dashboard: {
    readonly previewWidgetList: {
      readonly dataSource: string;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetList_widgetList">;
    };
  };
};
export type WAIntegrationListQuery = {
  response: WAIntegrationListQuery$data;
  variables: WAIntegrationListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storecastId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataSource",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WAIntegrationListQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v2/*: any*/),
          "concreteType": "Dashboard",
          "kind": "LinkedField",
          "name": "dashboard",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": (v3/*: any*/),
              "concreteType": "WidgetList",
              "kind": "LinkedField",
              "name": "previewWidgetList",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetList_widgetList"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WAIntegrationListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "WidgetList",
            "kind": "LinkedField",
            "name": "previewWidgetList",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "WidgetListSection",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WidgetListItem",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rightText",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rightTextSuffix",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "info",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isWidgetListItemInfo"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "style",
                                    "value": "DEFAULT"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "storeFormattedDate",
                                "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
                              }
                            ],
                            "type": "StoreZonedDate",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "text",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "italic",
                                "storageKey": null
                              }
                            ],
                            "type": "WidgetListItemInfoText",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4caf592f79cbe4bc19c3b15464fbad9a",
    "id": null,
    "metadata": {},
    "name": "WAIntegrationListQuery",
    "operationKind": "query",
    "text": "query WAIntegrationListQuery(\n  $storecastId: ID!\n  $input: PreviewWidgetListInput!\n) {\n  dashboard(id: $storecastId) {\n    previewWidgetList(input: $input) {\n      dataSource\n      ...WidgetList_widgetList\n      id\n    }\n    id\n  }\n}\n\nfragment WidgetList_listItemInfo on WidgetListItemInfo {\n  __isWidgetListItemInfo: __typename\n  __typename\n  ... on StoreZonedDate {\n    storeFormattedDate(style: DEFAULT)\n  }\n  ... on WidgetListItemInfoText {\n    text\n    italic\n  }\n}\n\nfragment WidgetList_widgetList on WidgetList {\n  id\n  title\n  dataSource\n  sections {\n    title\n    items {\n      title\n      rightText\n      rightTextSuffix\n      info {\n        __typename\n        ...WidgetList_listItemInfo\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7df9e62f109d1b5bee0270c7f41ced10";

export default node;
